import { useQuery } from '@apollo/client';
import { cloneDeep, mergeWith } from 'lodash';
import { TENANT_CONFIG_QUERY } from 'op-components/RO/Base/TenantConfigQuery';
import { TenantConfigQueryData } from 'op-interfaces/graph';
import { CurrentAppConfig } from 'op-pages/RO/Careplan/AppConfig';
import { AppConfigOverrides, BaseConfigInterface } from 'op-pages/RO/Careplan/AppConfig/types';
import Logger from 'shared-components/utils/Logger';

const logger = new Logger('useTenantAppConfig');

const parseOverrides = (raw: string | null | undefined): AppConfigOverrides => {
  if (!raw) return {};
  try {
    return JSON.parse(raw) as AppConfigOverrides;
  } catch (err) {
    logger.error('parseOverrides', 'failed to parse appConfigOverrides', err);
    return {};
  }
};

const replaceArrays = (_: unknown, srcValue: unknown): unknown => (Array.isArray(srcValue) ? srcValue : undefined);

let cachedRaw: string | null = null;
let cachedConfig: BaseConfigInterface | null = null;

const buildMerged = (raw: string | null): BaseConfigInterface => {
  if (cachedConfig !== null && cachedRaw === raw) return cachedConfig;
  cachedRaw = raw;
  cachedConfig = mergeWith(cloneDeep(CurrentAppConfig), parseOverrides(raw), replaceArrays);
  return cachedConfig;
};

export const useTenantAppConfig = (): BaseConfigInterface => {
  const { data } = useQuery<TenantConfigQueryData>(TENANT_CONFIG_QUERY);
  const raw = data?.tenantConfig?.appConfigOverrides ?? null;
  return buildMerged(raw);
};
